<template>
    <teleport to="body">
        <div class="modal fade" :id="uid" tabindex="-1" :aria-labelledby="`${uid}-label`" aria-hidden="true">
            <div class="modal-dialog" :class="size ? `modal-${size}` : null">
                <div class="modal-content">
                    <slot name="modal-header">
                        <div class="modal-header" :class="[seamless ? 'border-bottom-0' : null]">
                            <h5 class="modal-title" :id="`${uid}-label`">{{title}}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" v-if="closeButton" />
                        </div>
                    </slot>
                    <div class="modal-body">
                        <slot />
                    </div>
                    <div class="modal-footer">
                        <slot name="modal-footer"></slot>
                    </div>
                </div>
            </div>
        </div>
    </teleport>
</template>

<script>
import uniqid from 'uniqid';
import bootstrap from '@/../node_modules/bootstrap/dist/js/bootstrap';

export default {
    name: 'AlzataDialog',
    emits: ['alza-dialog-shown', 'alza-dialog-hidden'],
    props: {
        size: String,
        title: String,
        visible: Boolean,
        closeButton: {
            type: Boolean,
            default: true,
        },
        seamless: Boolean,
    },
    mounted() {
        this.element = document.getElementById(this.uid);
        this.element.addEventListener('shown.bs.modal', this.handleShown);
        this.element.addEventListener('hidden.bs.modal', this.handleHidden);
        this.handle = new bootstrap.Modal(this.element, {
            backdrop: true,
            keyboard: true,
            focus: true,
        });
    },
    unmounted() {
        this.element.removeEventListener('shown.bs.modal', this.handleShown);
        this.element.removeEventListener('hidden.bs.modal', this.handleHidden);
    },
    methods: {
        show() {
            this.handle.show();
        },
        hide() {
            this.handle.hide();
        },
        handleShown() {
            this.isVisible = true;
            this.$emit('alza-dialog-shown');
        },
        handleHidden() {
            this.isVisible = false;
            this.$emit('alza-dialog-hidden');
        },
    },
    watch: {
        visible(newVal) {
            if (!this.isVisible && newVal) {
                this.handle.show();
            }
            else if (this.isVisible && !newVal) {
                this.handle.hide();
            }
        },
    },
    data() {
        return {
            handle: null,
            isVisible: false,
            uid: uniqid(),
        };
    },
};
</script>